import SEO from "@/components/SEO";
import { FadeUp } from "@/components/Reveal";
import { PROFESSIONAL, WHATSAPP_DISPLAY, waLink } from "@/data/site";

const SECTIONS = [
  {
    title: "1. Quais dados são tratados",
    text: "Este site não armazena dados pessoais em servidores próprios. O formulário de contato apenas organiza as informações que você escolhe fornecer (nome, WhatsApp, tipo de atendimento procurado e mensagem opcional) e as envia diretamente para o WhatsApp profissional, por meio do seu próprio dispositivo.",
  },
  {
    title: "2. Finalidade",
    text: "As informações enviadas pelo WhatsApp são utilizadas exclusivamente para responder ao seu contato, compreender a demanda e orientar sobre os atendimentos. Não utilizamos dados — em especial dados relacionados à saúde — para publicidade comportamental.",
  },
  {
    title: "3. Compartilhamento",
    text: "As conversas acontecem na plataforma WhatsApp, sujeitas aos termos e à criptografia do próprio aplicativo. Não vendemos, cedemos ou compartilhamos seus dados com terceiros para fins de marketing.",
  },
  {
    title: "4. Sigilo profissional",
    text: "Informações compartilhadas no contexto do atendimento psicológico são protegidas pelo sigilo profissional, conforme o Código de Ética Profissional do Psicólogo.",
  },
  {
    title: "5. Seus direitos (LGPD — Lei nº 13.709/2018)",
    text: "Você pode solicitar, a qualquer momento, a confirmação, o acesso, a correção ou a eliminação dos seus dados pessoais, bem como revogar o consentimento para contato.",
  },
  {
    title: "6. Cookies",
    text: "Este site não utiliza cookies de rastreamento publicitário. Caso ferramentas de métricas (como Google Analytics) sejam ativadas futuramente, esta política será atualizada e o consentimento será solicitado.",
  },
  {
    title: "7. Contato do controlador",
    text: `Controladora dos dados: ${PROFESSIONAL.fullName}, ${PROFESSIONAL.titles}, ${PROFESSIONAL.crp}. Para exercer seus direitos ou esclarecer dúvidas, fale pelo WhatsApp ${WHATSAPP_DISPLAY}.`,
  },
];

const Privacidade = () => (
  <>
    <SEO
      title="Política de Privacidade | Sabrina Mota Psicóloga"
      description="Como Sabrina Mota — Psicologia e Neuropsicologia trata seus dados pessoais, em conformidade com a LGPD e o sigilo profissional da Psicologia."
      path="/privacidade"
    />
    <section className="pt-28 lg:pt-40" data-testid="privacidade-page">
      <div className="container-x max-w-3xl pb-20 lg:pb-28">
        <FadeUp>
          <p className="eyebrow">LGPD</p>
          <h1 className="mt-5 font-serif text-4xl font-light leading-[1.08] tracking-tight text-ink sm:text-5xl" data-testid="privacidade-title">
            Política de <em className="italic text-raiz-700">Privacidade</em>
          </h1>
        </FadeUp>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <FadeUp key={s.title}>
              <section data-testid={`privacidade-${s.title.slice(0, 3)}`}>
                <h2 className="font-serif text-xl font-normal text-ink">{s.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-ink/70 sm:text-base">{s.text}</p>
              </section>
            </FadeUp>
          ))}
        </div>
        <FadeUp className="mt-12">
          <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="privacidade-whatsapp-link" className="text-sm text-raiz-800 underline underline-offset-4">
            Falar comigo pelo WhatsApp
          </a>
        </FadeUp>
      </div>
    </section>
  </>
);

export default Privacidade;
